import DashboardLayout from '../layouts/DashboardLayout'
import SetupScript from '../pages/manage-script/SetupScript'
import ManageScript from '../pages/manage-script/manageScript'
import ManageBrandName from '../pages/manage-script/manageBrandName'

export const scriptMenu = {
    path: '/manage-setup',
    component: DashboardLayout,
    name: 'manage-setup',
    children: [
        {
            path: '/',
            components: { default: SetupScript },
            meta: {
                roles: ['contact_read', 'dashboard_read'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Quản lý Set up kịch bản'
                }]
            },
        },
    ],
}


export const scriptManageMenu = {
    path: '/manage-script',
    component: DashboardLayout,
    name: 'manage-script',
    children: [
        {
            path: '/',
            components: { default: ManageScript },
            meta: {
                roles: ['contact_read', 'dashboard_read'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Quản lý kịch bản'
                }]
            },
        },
    ],
}

export const manageBrandName = {
    path: '/manage-brand',
    component: DashboardLayout,
    name: 'manage-brand',
    children: [
        {
            path: '/',
            components: { default: ManageBrandName },
            meta: {
                roles: ['contact_read', 'dashboard_read'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Quản lý BrandName'
                }]
            },
        },
    ],
}